import LinkIcon from '@mui/icons-material/Link';
import RepeatOneIcon from '@mui/icons-material/RepeatOneRounded';
import RepeatIcon from '@mui/icons-material/RepeatRounded';
import Typography from '@mui/material/Typography';
import type React from 'react';
import QIllustration from 'components/QIllustration';
import QPanelButton from 'components/QPanelButton';

import { useStyles } from '../styles';

type Props = {
  isTransfer: boolean;
  isIncome: boolean;
  createRecurring: () => void;
  startRecurringSelect: () => void;
  doOneTimeBill: () => void;
};

export default function RecurringOptions({
  isTransfer,
  isIncome,
  createRecurring,
  startRecurringSelect,
  doOneTimeBill,
}: Props): React.JSX.Element {
  const { classes } = useStyles();
  let recurringName;
  let copyText;
  if (isTransfer) {
    recurringName = 'transfer';
    copyText = 'transfers';
  } else {
    recurringName = isIncome ? 'income' : 'bill or subscription';
    copyText = isIncome ? 'income' : 'bills and subscriptions';
  }

  return (
    <div className={classes.recurringRoot}>
      <QIllustration name='upcoming' size='md' />
      <div className={classes.recurringColumn}>
        <Typography className={classes.recurringSubtitle}>
          {`Linking transactions to recurring ${copyText} helps with planning and tracking payments in Spending Plan.` +
            " (You can manually link to an existing recurrence if we weren't able to auto-match it.)"}
        </Typography>
        <QPanelButton
          title={`Create a new recurring ${recurringName}`}
          subtitle='Set the frequency to plan for upcoming payments.'
          startIcon={<RepeatIcon />}
          onClick={createRecurring}
          id='create-new-recurring-button'
        />
        <QPanelButton
          title={`Link to existing ${recurringName}`}
          subtitle="Assign this transaction to a recurrence that's already set up."
          startIcon={<LinkIcon />}
          onClick={startRecurringSelect}
          id='link-existing-button'
        />
        {!isIncome && !isTransfer && (
          <QPanelButton
            title='Mark as one-time bill'
            subtitle='No future payments, but added to bills in your Spending Plan.'
            startIcon={<RepeatOneIcon />}
            onClick={doOneTimeBill}
            hideArrow
            id='mark-as-bill-button'
          />
        )}
      </div>
    </div>
  );
}
